module.exports = new __parcel__URL__("fire.b85d78ff.gif").toString();